import { useEffect } from 'react';
import Card from '../components/Card';
import Header from '../components/Header';
import Loading from '../components/Loading';
import { useSelector, useDispatch } from 'react-redux';
import { fetchCard } from '../store/cards/action';
import Search from '../components/Search';
import useAlert from '../hooks/useAlert';

const Home = () => {
  const message = 'Welcome To Yu Gi Oh Deck Builder (Monster Only)'

  const { cards, isLoading } = useSelector((state) => {
    return state.cards
  })

  const dispatch = useDispatch()
  const swal = useAlert

  useEffect(() => {
    dispatch(fetchCard())
      .catch(err => {
        swal('error', 'Card Not Found') 
    })
  }, [])

  return (
    <div
      className="
        flex
        flex-col
        min-h-screen
        items-center"
    >
      <Header msg={ message } />
      <section
        className="
          relative
          w-full
          bg-transparent
          lg:flex"
      >
        <div
          className="
            hidden
            lg:inline-block
            h-1/4
            lg:mx-4
            lg:my-8
            lg:w-96
            lg:p-3
            xl:my-8
            bg-gray-200
            rounded-lg
            bg-opacity-80
            mx-auto">
        <Search />
        </div>
        <div
          className="lg:flex-1">
          <section className="text-gray-600 body-font">
            <div className="container z-20 px-5 py-8 mx-auto ">
              <div className="flex flex-wrap -m-4 z-20">
                { isLoading ? <Loading /> :
                  cards.map(card => {
                    return (<Card isHome={true} key={ card.id } card={ card }/>)
                  })
                }
              </div>
            </div>
          </section>          
        </div>
      
      </section>
    </div>
  )
}

export default Home